import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import earingimg from '../../../../../Assets/nokaoi-imges/earrings.jpg'
import necklace from '../../../../../Assets/nokaoi-imges/necklace.jpg'
import bracelate from '../../../../../Assets/nokaoi-imges/bracelate.jpg'
import weddingrings from '../../../../../Assets/nokaoi-imges/wedding-rings.jpg'
import engagementrings from '../../../../../Assets/nokaoi-imges/eng-rings.jpg'
import { NavLink } from "react-router-dom/cjs/react-router-dom";

// Helper function for image paths
const getImagePath = (filename) => `${ImageUrl}theme/showcase/${filename}`;

const collections = [
  { name: "Rings", path: "/jewelry/fashion-rings", image: "Rings.webp" },
  { name: "Bracelets", path: "/jewelry/bracelets", image: "Bracelets.webp" },
  { name: "Earrings", path: "/jewelry/earrings", image: "Earrings.webp" },
  { name: "Necklaces", path: "/jewelry/necklaces", image: "Necklaces.webp" },
];

const ExploreCollection = () => {
  return (
    <section className="explore-collection">
      {/* <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop By Collection</h2>
          <p>Explore {Je_welryspelling} Collections by Style and Make a Statement.</p>
        </Heading>

        <Row>
          {collections.map(({ name, path, image }) => (
            <Col key={name} md={3} xs={6}>
              <div className="item text-center">
                <Link to={path} className="img-box" aria-label={`Shop ${name}`}>
                  <Image src={getImagePath(image)} alt={name} loading="lazy" />
                </Link>
                <Link to={path}>{name}</Link>
              </div>
            </Col>
          ))}
        </Row>
      </Container> */}
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-4 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" style={{
            visibility: 'visible',
            animationDuration: '1s',
            animationDelay: '0.5s',
            animationName: 'fadeInRight',
          }}>
            <div className="item-banner-jewelry3 banner-adv zoom-image line-scale style2">
              <NavLink to="/jewelry/earrings" className="adv-thumb-link"><img src={earingimg} alt="Earrings" /></NavLink>
              <div className="banner-info">
                <span className="title30 play-font dark  ">Earrings</span>
                <NavLink to="/jewelry/earrings" className="link-arrow dark wobble-horizontal">Shop now <i className="fa fa-long-arrow-right"></i></NavLink>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 wow fadeInDown" data-wow-duration="1s" data-wow-delay=".7s" style={{
            visibility: 'visible',
            animationDuration: '1s',
            animationDelay: '0.7s',
            animationName: 'fadeInDown',
          }}>
            <div className="item-banner-jewelry3 banner-adv zoom-image line-scale style2">
              <NavLink to="/jewelry/necklaces" className="adv-thumb-link"><img src={necklace} alt="Necklaces" /></NavLink>
              <div className="banner-info">
                <span className="title30 play-font dark  ">Necklaces</span>
                <NavLink to="/jewelry/necklaces" className="link-arrow dark wobble-horizontal">Shop now <i className="fa fa-long-arrow-right"></i></NavLink>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".9s" style={{
            visibility: 'visible',
            animationDuration: '1s',
            animationDelay: '0.9s',
            animationName: 'fadeInLeft',
          }}>
            <div className="item-banner-jewelry3 banner-adv zoom-image line-scale style2">
              <NavLink to="/jewelry/bracelets" className="adv-thumb-link"><img src={bracelate} alt="Bracelets" /></NavLink>
              <div className="banner-info">
                <span className="title30 play-font dark  ">Bracelets</span>
                <NavLink to="/jewelry/bracelets" className="link-arrow dark wobble-horizontal">Shop now <i className="fa fa-long-arrow-right"></i></NavLink>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 wow fadeInRight" data-wow-duration="1s" data-wow-delay="1.0s" style={{
            visibility: 'visible',
            animationDuration: '1s',
            animationDelay: '1s',
            animationName: 'fadeInRight',
          }}>
            <div className="item-banner-jewelry3 banner-adv zoom-image line-scale style2">
              <NavLink to="/jewelry/wedding-rings" className="adv-thumb-link"><img src={weddingrings} alt="Wedding Rings" /></NavLink>
              <div className="banner-info">
                <span className="title30 play-font dark  ">The Wedding Rings</span>
                <NavLink to="/jewelry/wedding-rings" className="link-arrow dark wobble-horizontal">Shop now <i className="fa fa-long-arrow-right"></i></NavLink>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="1.0s" style={{
            visibility: 'visible',
            animationDuration: '1s',
            animationDelay: '1s',
            animationName: 'fadeInLeft',
          }}>
            <div className="item-banner-jewelry3 banner-adv zoom-image line-scale style2">
              <NavLink to="/engagement-rings" className="adv-thumb-link"><img src={engagementrings} alt="Wedding Rings" /></NavLink>
              <div className="banner-info">
                <span className="title30 play-font dark  ">The Engagement Rings</span>
                <NavLink to="/engagement-rings" className="link-arrow dark wobble-horizontal">Shop now <i className="fa fa-long-arrow-right"></i></NavLink>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ExploreCollection;
